import { simulatedFault, resetFaults } from './faults'

/** Backwards-compatible alias used by the request layer. */
export const simulationState = simulatedFault

export function resetSimulation(): void {
  resetFaults()
}
